import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { PrintRequest } from '../../requests/totem-printer/print.request';

@Injectable({
  providedIn: 'root'
})
export class PrintService extends CommonService{

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public printTicket(body: PrintRequest): Observable<ReturnStruct>{

    let uri = `Print`

    return this.httpClient.post<ReturnStruct>(environment.urlApiTotemPrinter + uri, body)
    .pipe(
      catchError(this.handleError)
    )
  }
}
